import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './styles.scss';
import {
  EmmaIcon,
  EmmaSpace,
  EmmaStringTemplate,
  EmmaText,
  EmmaTheme,
  useBreakpoint,
} from '@axa-asia/emma-stylesheet';
import { useSelector } from 'react-redux';
import {
  getChangeAddressNote,
  getPolicyServiceFormUrl,
} from '../../selectors/changeAddressSelector';
import { isApp, resolveLocalizedText } from '../../../../utils';
import classNames from 'classnames';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { gaClickAbleElement } from '../../../../utils/generalGaEventAnalytics';

const SHOW_MORE = {
  en: 'Show more',
  zh: '顯示更多',
};

const SHOW_LESS = {
  en: 'Show less',
  zh: '收起',
};

const EditAddressNote: React.FC = () => {
  const changeAddressNote = useSelector(getChangeAddressNote);
  const bp = useBreakpoint();
  const [isShowAll, setIsShowAll] = useState(false);
  const policyServiceFormUrl = useSelector(getPolicyServiceFormUrl);
  const policyServicingFormLabel = useMemo(() => {
    return resolveLocalizedText(changeAddressNote.policyServicingForm);
  }, [changeAddressNote]);

  const handleOpenPdf = useCallback(() => {
    gaClickAbleElement(policyServicingFormLabel);
    const url = resolveLocalizedText(policyServiceFormUrl);
    if (isApp()) {
      EmmaFactory.createInstance()
        .then((emma) => {
          emma.instance.goTo(`system/open-pdf?pdfUrl=${url}`);
        })
        .catch((e) => {
          console.error('Error in handleOpenPdf', e);
        });
    } else {
      window.open(url, '_blank');
    }
  }, [policyServiceFormUrl, policyServicingFormLabel]);

  useEffect(() => {
    if (bp === 'lg') {
      setIsShowAll(true);
    }
  }, [bp]);

  return (
    <div className="editAddressNote-noteContainer">
      <div className="editAddressNote-noteContainer-card">
        <EmmaIcon iconKey={'functional/idea'} size={24}></EmmaIcon>
        <div className={EmmaSpace.pl8}>
          <div className={EmmaText['Title_S/LooseContent/Left/MineShaft']}>
            {resolveLocalizedText(changeAddressNote.title)}
          </div>
          <div className={EmmaText['BodyTextS/line-15em/Left/MineShaft']}>
            <EmmaStringTemplate
              template={resolveLocalizedText(
                isShowAll
                  ? changeAddressNote.contentFull
                  : changeAddressNote.contentShort,
              )}
              items={{
                policyServicingForm: {
                  text: policyServicingFormLabel,
                  style: {
                    color: EmmaTheme['icon/blue'],
                    cursor: 'pointer',
                  },
                  onClick: handleOpenPdf,
                },
              }}
            />
          </div>
          {bp === 'sm' && (
            <div
              className={classNames(
                'd-flex flex-row editAddressNote-noteContainer-toggle',
                EmmaText['BodyTextS/normal-12em/Left/Indigo'],
                EmmaSpace.pt8,
              )}
              onClick={() => setIsShowAll((prev) => !prev)}
              data-enable-ga
              data-ga-type="button"
              data-ga-text={resolveLocalizedText(
                isShowAll ? SHOW_LESS : SHOW_MORE,
              )}
            >
              {resolveLocalizedText(isShowAll ? SHOW_LESS : SHOW_MORE)}
              <EmmaIcon
                className={EmmaSpace.ml4}
                iconKey={
                  isShowAll ? 'functional/arrow-top' : 'functional/arrow-bottom'
                }
                size={16}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAddressNote;
